import { useEffect, useRef, useState } from "react";

export default function SaunasSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {if (entry.isIntersecting) setVisible(true);},
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="saunaer" ref={ref} className="relative h-[80vh] md:h-screen overflow-hidden">
      <img
        src="https://media.base44.com/images/public/69ddf0e05a57ca57b48414c4/58e852f0f_ChatGPTImage10mai202612_26_11.png"
        alt="LYKKE Badstue interior – varm og komfortabel plass"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy" />
      
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

      <div
        className={`relative z-10 h-full flex flex-col justify-center px-6 md:px-12 max-w-[1440px] mx-auto transition-all duration-1000 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`
        }>
        
        <p className="text-sm tracking-widest-2xl font-body uppercase text-white/80 mb-6">
          Design og funksjonalitet
        </p>
        <h2 className="font-heading text-white text-3xl md:text-5xl lg:text-7xl font-light leading-[1.05] mb-6 max-w-2xl">
          Designed, crafted, and delivered.
        </h2>
        

        
        <button
          onClick={() => document.querySelector("#kontakt")?.scrollIntoView({ behavior: "smooth" })} className="text-white px-8 py-3.5 text-base font-body uppercase tracking-widest-xl self-start border border-white/30 hover:bg-white hover:text-black transition-all duration-300">

          
          Utforsk badstuer
        </button>
      </div>
    </section>);

}